<template>
  <!-- <v-flex
    v-if="this.component.enable.download"
    xs6
    sm2
    md2
    class="d-inline"
  > -->
  <div v-if="this.component.enable.download" class="d-inline">
    <v-tooltip bottom>
      <v-btn
        slot="activator"
        @click.native=" setPositionMenu($event)"
        class="bg_white"
      >
      <svg class="customIcon i_header" viewBox="0 0 24 24">
          <path
          fill="#000000"
              d="M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
      </svg>
        <!-- <svg class="customIcon i_header" viewBox="0 0 24 24">
          <path
            fill="#000000"
            d="M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M12,19L8,15H10.5V12H13.5V15H16L12,19Z"
          />
        </svg> -->
        <small>Enviar FTP</small>
      </v-btn>
      <span>Enviar PDF e/ou XML das notas selecionada</span>
    </v-tooltip>

    <v-menu
      v-model="menu"
      nudge-top="20"
      :position-x="menuX"
      :position-y="menuY"
      :close-on-content-click="true"
      bottom
      offset-y
    >
      <v-list id="options">
        <div id="title">Opções de envio</div>

        <v-list-tile class="item" v-for="(item, index) in items" :key="index">
          <v-list-tile-title @click="downloadMulti(item.evento)">
            <v-tooltip right>
              <div slot="activator" class="text-xs-center">
                <v-icon style="font-size: 15px;">{{item.icon}}</v-icon>
                {{ item.title }}
              </div>

              <span>{{item.tooltip}}</span>
            </v-tooltip>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    </div>
  <!-- </v-flex> -->
</template>
<script>
export default {
  props: ["component", "arraySelect", "empresa", "table", "conta"],
  data: () => ({
    menu: false,
    menuX: 0,
    menuY: 0,
    items: [
      {
        title: "XML",
        tooltip: "Enviar apenas XML das notas selecionadas",
        icon: "",
        evento: "xml"
      },
      {
        title: "PDF",
        tooltip: "Enviar apenas PDF das notas selecionadas",
        icon: "",
        evento: "pdf"
      },
      {
        title: "XML e PDF",
        tooltip: "Enviar XML e PDF das notas selecionadas",
        icon: "",
        evento: "xml-pdf"
      }
    ]
  }),
  methods: {
    setPositionMenu: function(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    downloadMulti: async function(evento) {
      let idNota = [];
      if (this.arraySelect.length > 0) {
        await this.arraySelect.forEach(function(item) {
          if (item) {
            idNota.push(item._id);
          }
        });
        let notas = { notas: idNota, acao: evento };
        this.setDownload(notas,this.arraySelect);
      } else {
        this.table.snackAlert();
        this.table.snack.text = "Necessário escolher ao menos uma nota";
        this.table.snack.show = true;
      }
    },
    setDownload: function(notas,itens) {
      //debugger;
      
      let url = this.$http.options.root;
      switch (this.component.name) {

        case "NFeRecebidas":
          url += "nfes/send/ftp";
          break;
        
        default:
          throw new Error("Não foi possísvel setar url para buscar zip");
      }
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-type", "application/json");
      this.activeGlobalLoader();
      
      let auxRmvGlobalLoader = this.desactiveGlobalLoader;
      xhr.onreadystatechange = async function() {
        if (xhr.readyState == 4 && xhr.status == 200) {
          if (notas.acao == 'xml-pdf'){
            await itens.forEach(function(item) {
              if (item) {
                item.ftpPython = 'pendente'
                item.ftpPythonPdf = 'pendente'
                item.logErroFtpPdf = ''
                item.logErroFtpXml = ''
              }
            });
          }else if (notas.acao == 'xml'){
            await itens.forEach(function(item) {
              if (item) {
                item.ftpPython = 'pendente'
                item.logErroFtpXml = ''
              }
            });
          }else if (notas.acao == 'pdf'){
            await itens.forEach(function(item) {
              if (item) {
                item.ftpPythonPdf = 'pendente'
                item.logErroFtpPdf = ''
              }
            });
          }
          auxRmvGlobalLoader();

        } else {
          auxRmvGlobalLoader();
        }
      };

      
      xhr.send(JSON.stringify(notas));
    },
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
};
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnEnviaFtp/BtnEnviaFtp.vue